import React from "react";

import { Amounts, Bet } from "src/components/common";
import { Controls } from "./components";
import { Speedometer, Version } from "src/components/common";
import { useDefault } from "./hooks";

export const Default = React.memo(() => {
  const { getAmountsProps, values } = useDefault();
  return (
    <div className={values.styles.panel}>
      <div className={values.styles.board}>
        <Amounts {...getAmountsProps()} />
        <Controls />
      </div>
      <Bet />
      <Speedometer />
      <Version />
    </div>
  );
});

Default.displayName = "Default";
